import { ReactNode } from "react";
import styles from "./FilterRangeInputs.module.css";

interface FilterRangeInputsProps {
  fromLabel: string;
  toLabel: string;
  from: ReactNode;
  to: ReactNode;
}

// A labeled "from"/"to" pair, shared by Number and Date filters' range mode - hosts whichever
// input each one needs (a numeric Input, or a DatePicker).
const FilterRangeInputs = ({ fromLabel, toLabel, from, to }: FilterRangeInputsProps) => (
  <div className={styles.range}>
    <label>
      <span>{fromLabel}</span>
      {from}
    </label>
    <label>
      <span>{toLabel}</span>
      {to}
    </label>
  </div>
);

export default FilterRangeInputs;
